import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import AccessoryList from '../../containers/accessory-list';
import AccessoryBodyTypeTabName from '../../blocks/accessory-body-type-tab-name';

const AccessoryListBlock = props => <AccessoryList {...props} />;
AccessoryListBlock.displayName = 'AccessoryList';

export default withDynamicComponents({
  componentWhitelist: [
    AccessoryBodyTypeTabName
  ],
  mapInputToOutput: [
    
  ],
})(AccessoryListBlock);



// WEBPACK FOOTER //
// ./src/blocks/accessory-list/index.jsx